interface IFileIdentifier {

}
type SiteLabelUploadFileProgress = 'succeeded' | 'inprogress' | 'failed';

class SiteLabelUpload
    extends SiteLabel<IFileIdentifier[], ISiteLabelConfig> {

    private readonly _dropEvent: (data: QueryUploadFile) => Promise<void>;
    private readonly _container: IQueryElement;
    private readonly _drop: QueryUpload;
    private readonly _files: IQueryElement;
    private readonly _provider: string;
    private readonly _global: string;
    private readonly _input: IQueryElement;

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel,  element: HTMLElement) {
        super(card, model, modelData, element);

        let input = this.query("input").first();
        let provider = input && input.getAttr("data-provider");
        let global = input && input.getAttr("data-global");
        let modelValue = this.getModelValue();
        let metaData = this.getModelData();

        if (input === null || provider === null || global === null)
            throw "Couldn't find the input element.";

        this._provider = provider;
        this._global = global;

        this._input = input;

        this._container = QueryElement.QueryElement("div")
            .addClass("upload");
           
        this._drop = new QueryUpload(document.createElement("div"), input)
            .addClass("drop")
            .setHtml(`<i>cloud_upload</i>${this.getSiteConfig().strings["drag your files here to upload."]}`)
            .appendTo(this._container);
        this._drop.on("dragover", () => this._container.addClass("drag"));
        this._drop.on("dragleave", () => this._container.removeClass("drag"));
        this._drop.on("drop", () => this._container.removeClass("drag"));
        
        this._files = QueryElement.QueryElement("div")
            .addClass("files")
            .appendTo(this._container);

        this.append(this._container);
        
        this._dropEvent = this._drop.dropEvent.on(async (a) => {     
            await this.addFile(a);
        });
        if (modelValue !== undefined) {
            for (let x = 0; x < modelValue.length; x++) {
                let uploadMeta = metaData[x];
                let uploadItem = modelValue[x];
                if(uploadMeta != null && uploadItem != null) {
                    let item = new SiteLabelUploadFile(
                        card,
                        this,
                        new QueryUploadFile(
                            {
                                name: uploadMeta.fileName || `file ${x}`,
                                size: 0,
                                type: ""
                            },
                            {
                                id: uploadItem,
                                preview: uploadMeta.preview
                            }), this._provider, this._global
                    ).appendTo(this._files);
                }
            }
        }

        // Click is handled by 
        this.off("click", null);
    }
    
    getInput() {
        return this._input;
    }
    getProvider() {
        return this._provider;
    }

    async addFile(file: QueryUploadFile) {
        var result = await new SiteLabelUploadFile(this.getCard(), this, file, this._provider, this._global)
            .appendTo(this._files)
            .upload();

        this.setValue(this.getValue());
        return result;
    }

    defaultConfig(): ISiteLabelConfig {
        return {
            popout: 'inline',
            scroll: "top"
        }
    }
    getValue() {
        let values = this.query(".files > div")
            .all<SiteLabelUploadFile, any>(a => {
                return { id: a.id, state: a.state };
            })
            .filter(a => a.state != "failed")
            .map(a => a.id);

        return values.length > 0 ? values : null;
    }
    setValue(value: string[] | null) {
        super.setValue(value || []);
    }

    async remove(removeInner = true) {
        await super.remove(removeInner);

        // Cleanup event
        this._drop.dropEvent.off(this._dropEvent);
    }
}

class SiteLabelUploadFile
    extends QueryElement<HTMLElement> {

    private readonly _icon: IQueryElement;
    private readonly _buttons: IQueryElement;
    private readonly _file: QueryUploadFile;
    private readonly _card: SiteCard;
    private readonly _provider: string;
    private readonly _global: string;
    private readonly _element: SiteLabelUpload;
    private _id: any;
    private _state: SiteLabelUploadFileProgress;

    public get id() { return this._id; }
    public get state() { return this._state; }

    constructor(card: SiteCard, element: SiteLabelUpload, file: QueryUploadFile, provider: string, global: string) {
        super(document.createElement("div"));

        this._card = card;
        this._element = element;
        this._file = file;
        this._provider = provider;
        this._global = global;
        this._state = "failed";

        this._icon = QueryElement.QueryElement("i")
            .setHtml(SiteLabelUploadFile.mimeToIcon(file.type));
        
        this._buttons = QueryElement.QueryElement("div")
            .addClass("buttons");
        
        let title = QueryElement.QueryElement("div")
            .addClass("title")
            .setHtml(file.name);

        // Init model:
        if(file.model !== undefined) {
            this._id = file.model.id;
            this._state = "succeeded";

            this.addButtons(this._id);
            if(file.model.preview !== undefined) {
                this.setPreview(file.model.preview);
            }
        }
        
        this.addClass("file")
            .append(this._icon)
            .append(this._buttons)
            .append(title);
    }
    async addButtons(id: string) {
        let downloadAction: IActionTypePost = {
            type: "Post",
            setModel: false,
            actionLink: {
                actionInfo: {
                    controller: "Api",
                    action: "FileGet"
                },
                model: {
                    id: id,
                    provider: this._provider
                }
            }
        };

        new SiteActionButton(this._card, {
            icon: "get_app",
            title: "",
            action: downloadAction,
            isFocusable: false
        })
        .appendTo(this._buttons)

        let rotateAction: IActionTypePost = {
            type: "Post",
            setModel: false,
            actionLink: {
                actionInfo: {
                    controller: "Api",
                    action: "ImageFlip"
                },
                model: {
                    id: id,
                    provider: this._provider
                }
            }
        };

        let button = new SiteActionButton(this._card, {
            icon: "rotate_right",
            title: "",
            action: rotateAction,
            isFocusable: false
        })
        .appendTo(this._buttons);
        
        button.on("click", async a => {
            this._card.makeFocusableActive(this._element);
            a.stop();
        });
        button.on("actionExecuted", async a => {
            if (this._file.model?.preview !== undefined) {
                this.setPreview(this._file.model?.preview);
            }
        });

        let deleteAction: IActionTypePost = {
            type: "Post",
            setModel: false,
            actionLink: {
                actionInfo: {
                    controller: "Api",
                    action: "FileDelete"
                },
                model: {
                    id: id,
                    provider: this._provider
                }
            }
        };
        new SiteActionButton(this._card, {
            icon: "delete",
            title: "",
            action: deleteAction,
            isFocusable: false
        })
        .appendTo(this._buttons)
        .on("click", async a => {
            await this.remove();
            this._card.makeFocusableActive(this._element);
            a.stop();
        });
    }
    async upload() {
        this._state = "inprogress";

        if(this._file instanceof QueryUploadFileUpload) {
            try {
                let response = await this._file.upload(
                    {
                        provider: this._provider,
                        global: this._global
                    }
                );

                // 200 OK with no JSON:
                if(response === undefined)
                    throw "Not recieved the information.";

                this._id = response.id;
                this.addButtons(response.id);
                if (response.preview !== undefined) {
                    this.setPreview(response.preview);
                }
                
                this._state = "succeeded";
                this.addClass("success");
            } catch(e) {
                this._state = "failed";
                this.addClass("failed");
            }
            
            // Set value after upload completed
            this._element.setValue(this._element.getValue());
        }

        return this;
    }

    setPreview(preview: string) {
        let style = this._icon.style();

        if (style !== undefined) {
            style.backgroundImage = `url(${this.getImageUrl(preview)}?${new Date().getTime()})`;
            this._icon.setHtml("");
        }
    }
    private getImageUrl(url: string) {
        return url.replace("/$$$x$$$/", "/c=128x128/");
    }
    private static mimeToIcon(mime: string) {
        if (mime.startsWith("image/"))
            return "image";
        else if (mime.startsWith("video/"))
            return "movie";
        else if (mime.startsWith("audio/"))
            return "audiotrack";
        else if (mime.startsWith("application") || mime.startsWith("text"))
            return "description";
        
        return "attachment";
    }
}